import { createApi } from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'
import { UserUploadRequest } from '../../types'

export type GetUploadsQueryPaylod = {
  user_id?: string
  post_id?: string
  comment_id?: string
}

export const uploadsApi = createApi({
  reducerPath: 'uploadsApi',
  baseQuery: baseQueryConfigured,
  tagTypes: ['Uploads'],
  endpoints: (builder) => ({
    uploadFiles: builder.mutation({
      query: (payload: UserUploadRequest) => {
        let urlObj;
        if (payload.commentId == null) {
          urlObj = {post_id: payload.postId}
        } else if (payload.postId == null) {
          urlObj = {comment_id: payload.commentId}
        } else {
          urlObj = {post_id: payload.postId, comment_id: payload.commentId}
        }
        return {
          url: generateUrl(urlObj),
          method: 'POST',
          body: payload.files,
        }
      },
      invalidatesTags: ['Uploads'],
    }),
    deleteUpload: builder.mutation({
      query: (id) => {
        return {
          url: `${CONSTANTS.API.UPLOADS}/${id}`,
          method: 'DELETE',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
    }),
  }),
})

const generateUrl = (queryParams: GetUploadsQueryPaylod) => {
  let query = new URLSearchParams(queryParams).toString()
  query = query.replace('undefined', '')
  return `${CONSTANTS.API.UPLOADS}${query.length > 0 ? '?' : ''}${query}`
}

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useUploadFilesMutation, useDeleteUploadMutation } = uploadsApi
